import script from "./SheetPasiveCash.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetPasiveCash.vue?vue&type=script&setup=true&lang=ts"

import "./SheetPasiveCash.vue?vue&type=style&index=0&id=066f52cc&lang=css"

const __exports__ = script;

export default __exports__